import React from 'react';
import Button from '../ui/Button';

function DirectorEventEntryFields({
  form,
  managerEntryOptions = [],
  managerLabel = 'Manager',
  onChange = () => {},
  reasonPlaceholder = '',
  submitLabel = 'Save',
  submitLoadingLabel = 'Saving…',
  submitting = false,
  extraFields = null
}) {
  const isEmployeeOnlySubject = Boolean(form.employeeProfileId) && !form.managerId;

  return (
    <>
      {isEmployeeOnlySubject ? (
        <label className="director-form-span">
          Person
          <input value={form.subjectLabel || 'Selected employee'} readOnly />
        </label>
      ) : (
        <label className="director-form-span">
          {managerLabel}
          <select
            value={form.managerId}
            onChange={(event) => onChange('managerId', event.target.value)}
            required
          >
            <option value="">Select manager</option>
            {managerEntryOptions.map((option) => (
              <option key={option.value} value={option.value}>{option.label}</option>
            ))}
          </select>
        </label>
      )}
      {extraFields}
      <label>
        Time Block
        <select value={form.timeBlock} onChange={(event) => onChange('timeBlock', event.target.value)}>
          <option value="AM">AM</option>
          <option value="PM">PM</option>
          <option value="FULL DAY">Full Day</option>
        </select>
      </label>
      <label>
        Start Date
        <input type="date" value={form.startDate} onChange={(event) => onChange('startDate', event.target.value)} required />
      </label>
      <label>
        End Date
        <input type="date" value={form.endDate} onChange={(event) => onChange('endDate', event.target.value)} required />
      </label>
      <label className="director-form-span">
        Reason
        <textarea value={form.reason} onChange={(event) => onChange('reason', event.target.value)} required placeholder={reasonPlaceholder} />
      </label>
      <div className="director-form-actions">
        <Button type="submit" loading={submitting} loadingLabel={submitLoadingLabel}>
          {submitLabel}
        </Button>
      </div>
    </>
  );
}

export default DirectorEventEntryFields;
